import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';
const {baseApi} = apiPrefix;

// 母渠道 选项
export const channelOptions = (params) => get(`${baseApi}/landingPageChannelConfig/channelList`, params);
// 子渠道 选项
export const subChannelOptions = (params) => get(`${baseApi}/landingPageSubChannelConfig/subChannelList`, params);
// 模板配置 - 下拉选项集合
export const getTemplateOptions = (params) => get(`${baseApi}/landPageTemplate/selectList`, params);
// 模板配置 - 通过保司获取产品code选项
export const getProductCodeOptionsByInsuranceCompany = (params) => get(`${baseApi}/landPageTemplate/selectProductByCompanyCode`, params);




// 赠险-城市-列表
export const getZxCityConfigList = (params) => {
  return post(`${baseApi}/zxCode/getCityConfigureList`, params);
}
// 赠险-城市-新增、修改
export const zxCityConfigAdd = (params) => {
  if (params.id){
    return post(`${baseApi}/zxCode/modifyCityConfigure`, params, {noValid: true});
  } else {
    return post(`${baseApi}/zxCode/addCityConfigure`, params, {noValid: true});
  }
}
// 赠险-城市-删除
export const zxCityConfigDelete = (params) => {
  return get(`${baseApi}/zxCode/deleteCityConfigure`, params);
}




// 赠险实时承保 - 列表
export function getImmediateInsureList(params){
  return post(`${baseApi}/zxCode/zxDataMonitor`, params);
}




// 模板资源 - 文件名称选项
export const getTemplateSourceFileNameOptions = (params) => get(`${baseApi}/landPageTemplateFileConfig/queryFileNameList`, params);
// 模板资源 - 文件名称 - 更新
export const sourceFileNameUpdate = (params) => post(`${baseApi}/landPageTemplateFileConfig/saveFileName`, params);
// 模板资源 - 列表
export const getTemplateSourceList = (params) => post(`${baseApi}/landPageTemplateFileConfig/list`, params);
// 模板资源 - 新增
export const templateSourceAdd = (originParams) => {
  const {operateType, ...params} = originParams;
  let link = `${baseApi}/landPageTemplateFileConfig/insert`;
  if (params.id > 0) link = `${baseApi}/landPageTemplateFileConfig/update`;

  if (operateType === 'copy'){
    link = `${baseApi}/landPageTemplateFileConfig/copyTemplateFile`;
    return post(link, params);
  }

  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(link, data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
// 模板资源 - 文件名称 - 列表
export const getFilenameList = (params={}) => post(`${baseApi}/templateFileNameConfig/queryList`, params);
// 模板资源 - 文件名称 - 批量新增
export const sourceFileNameBatchAdd = (params) => post(`${baseApi}/templateFileNameConfig/fileNameConfigSave`, params);


// 链接管理 - 列表
export const getLinkManagerList = (params={}) => post(`${baseApi}/landingPageLinkRecord/list`, params);


// 分流模板 - 列表
export const getDivideList = (params) => {
  return post(`${baseApi}/pageDiversionConfig/list`, params);
}
// 分流模板 - 通过分流添加获取产品code选项
export const getProductCodeOptionsByDivideAdd = (params) => post(`${baseApi}/pageDiversionConfig/listCode`, params);
// 分流模板 - 通过分流添加获取模板code选项
export const getTemplateCodeOptionsByDivideAdd = (params) => post(`${baseApi}/pageDiversionConfig/listTemplate`, params);
// 分流模板 - 新增
export const divideAdd = (params) => {
  return post(baseApi + "/pageDiversionConfig/updateAdd", params);
}
// 分流模板 - 生成分流策略
export const divideLinkCreate = (params) => {
  return post(baseApi + "/pageDiversionConfig/getUrl", params);
}
// 分流模板 - 新增
export const divideDetail = (params) => {
    return get(baseApi + "/pageDiversionConfig/detail", params);
}
// 分流模板 - 新增
export const divideBindChannel = (params) => {
    return post(baseApi + "/pageDiversionConfig/bindChannel", params);
}

export const getStrategyId = (params) => get(`${baseApi}/pageDiversionConfig/getStrategyId`, params);
// 分流模板 - 配置项
export const getDivideConfig = (params) => get(`${baseApi}/pageDiversionConfig/listConfig`, params);

export const pageDiversionConfigDelete = (params) => get(`${baseApi}/pageDiversionConfig/delete`, params);



/**
 * 推荐下拉选项集合
 *
 * @param {*} scene 场景。 channel 应用渠道； productType 产品类型； productCode 产品code； recommendCode 推荐产品code；
 * @param {*} productType 产品类型
 *
 */
export const getRecomendOptions = (params) => get(`${baseApi}/validateRecommend/getList`, params);
// 核保失败推荐 - 列表
export const getInsurefailRecommendList = (params) => post(`${baseApi}/validateRecommend/list`, params);
// 核保失败推荐 - 新增
export const insurefailRecommendAdd = (params) => {
  return post(`${baseApi}/validateRecommend/save`, params);
}


// 水滴公众号企微自动回复 - 下拉选项集合
export const getSdQwOptions = (params) => get(`${baseApi}/replyMsgConf/queryArg`, params);
// 水滴公众号企微自动回复 - 列表
export const getSdQwReplyList = (params) => post(`${baseApi}/replyMsgConf/list`, params);
// 水滴公众号企微自动回复 - 关键词详情
export const getSdQwReplyMsgInfo = (params) => post(`${baseApi}//replyMsgConf/msgInfo`, params);
// 水滴公众号企微自动回复 - 新增、更新
export const sdQwReplyAdd = (params) => {
  if (params.id){
    return post(`${baseApi}/replyMsgConf/update`, params);
  } else {
    return post(`${baseApi}/replyMsgConf/save`, params);
  }
}
